export default "__VITE_ASSET__BA0uXKYl__"